// Core libraries
import React, { useState } from 'react';

// External libs and components
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useTranslation } from 'react-i18next';
import { InProgressState } from '@common/model';
import { FormProvider, useForm } from 'react-hook-form';
import ProgressButton from '@common/components/ProgressButton';

// Internal libs

// Internal components

// Styles hook
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  }),
);

// Props type
type DriverRestoreModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

// Component
const DriverRestoreModal = ({ open, onClose, onSubmit }: DriverRestoreModalProps) => {
  const { t } = useTranslation('admin');
  const [submitState, setSubmitState] = useState<InProgressState>({ inProgress: false });
  const form = useForm();

  return (
    <FormProvider {...form}>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{t('driverRestore.titleText')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('driverRestore.bodyText')}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ProgressButton onClick={onClose} color="primary" disabled={submitState.inProgress}>
            {t('driverRestore.form.cancelButton')}
          </ProgressButton>
          <ProgressButton
            type="submit"
            onClick={onSubmit}
            color="primary"
            disabled={submitState.inProgress}
            loading={submitState.inProgress}
            autoFocus
          >
            {t('driverRestore.form.submitButton')}
          </ProgressButton>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};

export default DriverRestoreModal;
